"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AttributeOption = function AttributeOption(_ref) {
  var type = _ref.type,
      attributeId = _ref.attributeId,
      parentId = _ref.parentId,
      parent = _ref.parent,
      optionId = _ref.optionId,
      option = _ref.option,
      value = _ref.value,
      setFieldValue = _ref.setFieldValue;
  var name = option.name;

  var handleAttributeChange = function handleAttributeChange(event) {
    var _event$target = event.target,
        checked = _event$target.checked,
        name = _event$target.name;
    updateAttributeChoices(_objectSpread({}, value), attributeId, checked, name);

    if (parent) {
      updateAttributeChoices(_objectSpread({}, parent), parentId, checked, name);
    }
  };

  var updateAttributeChoices = function updateAttributeChoices(update, attributeId, checked, name) {
    if (type === "many") {
      if (checked) {
        if (update.choice) {
          update.choice.push(name);
        } else {
          update.choce = [name];
        }
      } else {
        var index = update.choice.indexOf(name);

        if (index > -1) {
          update.choice.splice(index, 1);
        }
      }
    } else {
      update.choice = [name];
    }

    setFieldValue("attributes.".concat(attributeId), update);
  };

  var optionSelected = function optionSelected(item) {
    return Boolean(item && item.choice && item.choice.includes(optionId));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-attribute-option flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-start"
  }, type === "many" ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    name: optionId,
    checked: optionSelected(value) || optionSelected(parent),
    value: optionId,
    color: "primary",
    onChange: handleAttributeChange,
    inputProps: {
      'aria-label': name
    }
  }) : /*#__PURE__*/_react.default.createElement(_Radio.default, {
    name: optionId,
    checked: optionSelected(value) || optionSelected(parent),
    value: optionId,
    color: "primary",
    onChange: handleAttributeChange,
    inputProps: {
      'aria-label': name
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginTop10"
  }, name));
};

var _default = AttributeOption;
exports.default = _default;